// extracted by mini-css-extract-plugin
module.exports = {"groupTitle":"groupTitle-3xbw_","reasons":"reasons-2ug9u","reason":"reason-3rU9b"};